export const CONVERSATION_STATUS_TYPES = {
  RESOLVED: 'resolved',
  OPEN: 'open',
  PENDING: 'pending'
};

export const CAMPAIGN_TRIGGER = {
    WIDGET: 'widget',
    NUDGE: 'nudge'
  };
